// extracted by css-extract-rspack-plugin
export default {"scrollable":"kKY9J"};